<template>
	<div class="votelist">
		<div v-for="(item,key) in familyList" :key="key" class="item_votelist">
            <div class="votelist_videos">
                <van-image width="2.92rem" height="2.17rem" :src="item.imgurl" @click="gotouch(item)"/>    
		        <div class="votelist_canvassing" @click="canvass(item)">
		        	拉票
		        </div>
            </div>           
            <div class="votelist_title">
                <div class="votelist_id">NO.{{item.id}}</div>
                <div class="votelist_cont">
                	<div class="votelist_name">{{item.name}}</div>
                	<div class="votelist_votes">{{item.votes}} 票</div>
                </div>
            </div> 
            <div class="votelist_footer">
            	<div class="mvbutton vote" @click="go(item)">
	                我要投票
	            </div>
            </div>           
        </div>
        <van-popup v-model="show" closeable :style="{ height: '100%',width: '100%' }" :close-icon="require('assets/img/common/colse.svg')">
            <video
              id="video" 
              class="video" 
              :src="mediaurl"
              controls = "true"
              :poster="imgurl"
              preload="auto" 
              webkit-playsinline="true" 
              playsinline="true"
              x-webkit-airplay="allow" 
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-video-orientation="portraint"
              style="object-fit:fill">
            </video> 
        </van-popup>
	</div>
</template>
<script>
    import './index.less'
    import { Popup,Image} from 'vant';   
    export default {
        name:"VoteList",
        props:{
            familyList:Array
        },
        data() {
            return {
                mediaurl: '',
                imgurl:'',
                show:false
            }
        },
        components: {
            vanImage:Image,
            vanPopup:Popup
        },
        methods: {
            go:function (val) {
                // console.log(val)
                this.$emit('goVote',val);
            },
            gotouch(item) {
                this.show = true
                this.mediaurl = item.mediaurl
                this.imgurl = item.imgurl
                // var myVideo=document.getElementById("video");
                // myVideo.play();
                // if (myVideo.paused) 
                //   myVideo.play(); 
                // else 
                //   myVideo.pause(); 
            },
            canvass(item){
                console.log(item)
            }
        }
    }
</script>